// Import model
import { DataviewFcb2BProductTypeOptionResponse } from '../models/DataviewFcb2BProductTypeOptionResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { Fcb2BProductTypeOption } from '../models/Fcb2BProductTypeOption';
import { FilterFcb2BProductTypeOptionRequest } from '../models/FilterFcb2BProductTypeOptionRequest';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { Fcb2BProductTypeOptionSerializer } from './Fcb2BProductTypeOptionSerializer';
import { FilterFcb2BProductTypeOptionRequestSerializer } from './FilterFcb2BProductTypeOptionRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewFcb2BProductTypeOptionResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewFcb2BProductTypeOptionResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewFcb2BProductTypeOptionResponse instance
   */
  static deserialize(json: string): DataviewFcb2BProductTypeOptionResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewFcb2BProductTypeOptionResponse instance
   */
  static fromObject(obj: any): DataviewFcb2BProductTypeOptionResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewFcb2BProductTypeOptionResponse');
    }


    const instance: DataviewFcb2BProductTypeOptionResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        Fcb2BProductTypeOptionSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterFcb2BProductTypeOptionRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewFcb2BProductTypeOptionResponse instances
   */
  static deserializeArray(json: string): DataviewFcb2BProductTypeOptionResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewFcb2BProductTypeOptionResponse instance to a JSON string
   */
  static serialize(instance: DataviewFcb2BProductTypeOptionResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewFcb2BProductTypeOptionResponse instance to a plain object
   */
  static toObject(instance: DataviewFcb2BProductTypeOptionResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        Fcb2BProductTypeOptionSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterFcb2BProductTypeOptionRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewFcb2BProductTypeOptionResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewFcb2BProductTypeOptionResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
